import * as React from "react";
import EdButton from "../../../../generic/edButton";
import DeviceContext from "../../../../service/indentifyDevice";
import ObOrderLog, { IOrderLog } from "../obOrderLog";
import { ChipColorKeyComb } from "../../obConstants";
import { AEqGetOrderLogs } from "../../../../service/orderBook/obApiService";
import { dateTimeFormat } from "../../../../service/dateTimeService";
import moment from "moment";
import ObAssetDetailPopup from "../../generic/obAssetDetailPopup";
import ObEquityConvertDesk from "../../obConvertPositions/obEquityConvertDesk";
import { numValChk } from "../../../../service/generic/numValueChk";

export interface ObEqDtlContentProps {
	data: any;
	isTodayOrder: boolean;
	showTradeTab: boolean;
	tradeData: any;
	onCancelClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export interface ObEqDtlContentState {
	logs: Array<IOrderLog>;
	showTradePopup: boolean;
}

class ObEqDtlContent extends React.Component<ObEqDtlContentProps, ObEqDtlContentState> {
	state: ObEqDtlContentState = { logs: [], showTradePopup: this.props.showTradeTab };

	isMobile = DeviceContext().isMobile;

	onButtonClick(e: React.MouseEvent<HTMLButtonElement>) {
		console.log(e);
	}

	eqOrderLogs = (res: any) => {
		if (res.data) {
			this.setState({
				logs: res.data.ord.map((ord: any) => ({
					time: moment(dateTimeFormat(ord.rcvEpTim)).format("D MMM 'YY | HH:mm:ss"),
					sts: ord.sts
				}))
			});
		}
	};

	getOrderLogs = () => {
		AEqGetOrderLogs(this.eqOrderLogs, this.props.data.ordID);
	};

	componentDidMount() {
		this.getOrderLogs();
	}

	render() {
		return (
			<div>
				<div className="dtl_wrp eq_detl_cont_wrap">
					<div className="dtl_wrp_rw eq_info_row  mob_reverse">
						<div className="dtls_cont dtl_lft">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Traded Quantity</label>
								<label className="dtl_amt taRight">{this.props.data.flQty || "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Pending Quantity</label>
								<label className="dtl_amt taRight">{this.props.data.pdQty || "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Order Quantity</label>
								<label className="dtl_amt taRight">{this.props.data.ntQty || this.props.data.qtyTF || "--"}</label>
							</label>
						</div>

						<div className="dtls_cont  dtl_right">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Traded Price</label>
								<label className="dtl_amt taRight">{numValChk(this.props.data.avgPrc) ? "₹" + this.props.data.avgPrc : "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Trigger Price</label>
								<label className="dtl_amt taRight">{numValChk(this.props.data.trgPrc) ? "₹" + this.props.data.trgPrc : "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Order Price</label>
								<label className="dtl_amt taRight">
									{numValChk(this.props.data.prc)
										? "₹" + this.props.data.prc
										: numValChk(this.props.data.prcTF)
										? "₹" + this.props.data.prcTF
										: "--"}
								</label>
							</label>
						</div>
					</div>
					<hr className="slim_line" />
					<div className="dtl_wrp_rw eq_info_row brdTp">
						<div className="dtls_cont dtl_lft">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Product Type</label>
								<label className="dtl_amt taRight">{this.props.data.prdCode || "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Order Type</label>
								<label className="dtl_amt taRight">{this.props.data.ordTyp || "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Exchange</label>
								<label className="dtl_amt taRight">{this.props.data.exc || "--"}</label>
							</label>
						</div>
						<div className="dtls_cont  dtl_right">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Validity</label>
								<label className="dtl_amt taRight">{this.props.data.dur || "--"}</label>
							</label>
							{(this.props.data.dur === "GTC" || this.props.data.dur === "GTD") && (
								<label className="dtl_lbl">
									<label className="dtl_hd taLeft">Order Validation Date</label>
									<label className="dtl_amt taRight">{this.props.data.vlDt || "--"}</label>
								</label>
							)}
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Disclosed Quantity</label>
								<label className="dtl_amt taRight">{this.props.data.dsQty || "--"}</label>
							</label>
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Order Placed by</label>
								<label className="dtl_amt taRight">{this.props.data.userID || "--"}</label>
							</label>
						</div>
					</div>
					<hr className="slim_line" />
					<div className="dtl_wrp_rw eq_info_row brdTp">
						<div className="dtls_cont dtl_lft bd-b0 ">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Order No.</label>
								<label className="dtl_amt taRight">{this.props.data.ordID || "--"}</label>
							</label>
							{(this.props.data.dur === "GTC" || this.props.data.dur === "GTD") && (
								<label className="dtl_lbl">
									<label className="dtl_hd taLeft">Trigger Id</label>
									<label className="dtl_amt taRight">{this.props.data.trgId || "--"}</label>
								</label>
							)}
						</div>
						<div className="dtls_cont dtl_right ">
							<label className="dtl_lbl">
								<label className="dtl_hd taLeft">Exchange Order No.</label>
								<label className="dtl_amt taRight">{this.props.data.exONo || "--"}</label>
							</label>
						</div>
					</div>
				</div>
				{(this.props.data.dur === "GTC" || this.props.data.dur === "GTD") && (
					<>
						<hr className="slim_line" />
						<div className="note_sect">
							<label className="note_tit">Note</label>
							<p className="note_text">
								Since this is a GTC/GTD order, in case the order doesn’t get executed for the day, it shall get cancelled post market
								hours and will be placed again the next trading day until date of validity
							</p>
						</div>
					</>
				)}
				{this.props.isTodayOrder && (
					<>
						{/* buttons to perform different actions on click */}
						{ChipColorKeyComb[this.props.data.sts] !== "red" && (
							<div className="ob_btns mg-t20 mg-b50">
								<div className="btn_left">
									{ChipColorKeyComb[this.props.data.sts] === "blue" && (
										<>
											{/* button to cancel */}
											<EdButton
												value="Cancel Order"
												btnTyp="secondary"
												onClick={this.props.onCancelClick}
												className="mg-r20"
												slim
											/>
											{/* button to modify */}
											<EdButton value="Modify Order" btnTyp="secondary" onClick={this.onButtonClick} slim />
										</>
									)}
								</div>
								{this.props.showTradeTab && !this.isMobile && (
									<div className="btn_rgt">
										{/* button to convert positions */}
										<EdButton
											value="Convert Positions"
											btnTyp="primary"
											onClick={() => this.setState({ showTradePopup: true })}
											slim
										/>
									</div>
								)}
							</div>
						)}

						{/* Retyy button  will so on rejection*/}
						{ChipColorKeyComb[this.props.data.sts] === "red" && (
							<div className="mg-t20 mg-b40">
								<EdButton value="Retry" btnTyp="secondary" onClick={this.onButtonClick} slim={this.isMobile ? false : true} />
							</div>
						)}

						{/* order log progress bar steps */}
						{this.state.logs.length > 0 && this.props.isTodayOrder && <ObOrderLog logs={this.state.logs} />}
					</>
				)}
				{this.state.showTradePopup && (
					<ObAssetDetailPopup>
						<ObEquityConvertDesk data={this.props.tradeData} onBackClick={() => this.setState({ showTradePopup: false })} />
					</ObAssetDetailPopup>
				)}
			</div>
		);
	}
}

export default ObEqDtlContent;
